import styles from './index.module.scss'

import BannerFrame1 from '@/assets/image/home/b4.svg'
import BannerFrame2 from '@/assets/image/home/b_top_light.svg'
import BannerFrame3 from '@/assets/image/home/b_right_dark.svg'
import BannerFrame4 from '@/assets/image/home/b_left_dark.svg'
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import DisplayText from '../../../../components/DisplayText';

const bannerFrames = [BannerFrame1, BannerFrame2, BannerFrame3, BannerFrame4]

const bannerSubtitleLines = [
  'Execution only happens if constraints are satisfied.',
]

const getBannerRevealDelay = (delay) => ({ '--banner-reveal-delay': `${delay}ms` })

const AnimatedBanner = ({ className = '', animated = true }) => {
  const frames = animated ? bannerFrames : [BannerFrame1]

  return (
    <div className={`${styles.bannerAnimation} ${className}`}>
      {
        frames.map((frame, index) => (
          <img
            key={frame}
            src={frame}
            alt=""
            aria-hidden="true"
            className={`${styles.bannerFrame} ${styles[`bannerFrame${index + 1}`]}`}
          />
        ))
      }
    </div>
  )
}

const Banner = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={`${styles.card} relative w-[100%] overflow-hidden`}>
      {
        isMobile?(
          <>
            <div className={styles.bannerAnimationMobileWrap}>
              <AnimatedBanner className={styles.bannerAnimationMobile} />
            </div>
            <div className={`${styles.box} relative`}>
              <div className={``}>
                <h2 className={`${styles.bannerRevealItem} relative pt-[40px]`} style={getBannerRevealDelay(350)}>
                  <DisplayText fullText="The banking infrastructure for autonomous capital" />
                </h2>
                <p className={`${styles.box_subtitle}`}>
                  {bannerSubtitleLines.map((line, index) => (
                    <span
                      key={line}
                      className={`${styles.bannerRevealItem} ${styles.bannerRevealLine}`}
                      style={getBannerRevealDelay(700 + index * 350)}
                    >
                      {line}
                    </span>
                  ))}
                </p>

                <div className={`${styles.bannerRevealItem} get-touch-btn`} style={getBannerRevealDelay(1400)}>
                  <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                    <div className={`get-touch-btn-text text-[16px]`}>Request Demo</div>
                  </Link>
                  <div className={`get-touch-btn-mask`} />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className={`${styles.box} w-1340 flex`}>
            <div className={`w-[880px] pt-[260px] relative z-10`}>
              <h2 className={`${styles.bannerRevealItem} relative h-[226]`} style={getBannerRevealDelay(0)}>
                <DisplayText fullText="The banking infrastructure for autonomous capital" />
              </h2>
              <p className={`${styles.box_subtitle} w-[736px] relative mb-[24px]`}>
                {bannerSubtitleLines.map((line, index) => (
                  <span
                    key={line}
                    className={`${styles.bannerRevealItem} ${styles.bannerRevealLine}`}
                    style={getBannerRevealDelay(450 + index * 350)}
                  >
                    {line}
                  </span>
                ))}
              </p>


              <div className={`${styles.bannerRevealItem} get-touch-btn`} style={getBannerRevealDelay(1150)}>
                <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                  <div className={`get-touch-btn-text text-[16px]`}>Request Demo</div>
                </Link>
                <div className={`get-touch-mask`} />
              </div>
            </div>
            <div className={`absolute z-8 top-[94px] right-[-64px]`}>
              <AnimatedBanner className={styles.bannerAnimationDesktop} animated={false} />
            </div>
          </div>
        )
      }
    </div>
  )
}

export default Banner
